import React, { FC } from 'react'
import { IconProps, SIZES } from '../exports'

/* Styles ======================================================================================== */
import { AddCircleStyled } from './add-circle.styled'

const AddCircle: FC<IconProps> = props => {
  const { size = 'md', isAnimated, color, ...others } = props
  const theme = {
    color: `${color ? color : 'currentColor'}`,
  }

  return (
    <AddCircleStyled
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={isAnimated !== undefined ? 'is-animated' : ''}
      theme={theme.color}
      {...SIZES[size]}
      {...others}
    >
      <path
        d="M16 26L16 6M6 16H16M26 16H20"
        className="stroke draw-stroke-path path-1"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M28.1223 9.00117C31.9877 15.6961 29.6938 24.257 22.9988 28.1223C16.3039 31.9877 7.74302 29.6938 3.87767 22.9988C0.0123209 16.3039 2.30619 7.74302 9.00117 3.87767C13.9858 0.999805 20.0047 1.53614 24.3499 4.76109"
        className="stroke draw-stroke-path path-2"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </AddCircleStyled>
  )
}

export default AddCircle
